import script from "./QueuedDiscountActionsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueuedDiscountActionsPage.vue?vue&type=script&setup=true&lang=ts"

import "./QueuedDiscountActionsPage.vue?vue&type=style&index=0&id=c36f14b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c36f14b8"]])

export default __exports__